/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomVersionMetadata {
    getFixupPrototypeFunction() { return AppSecopsSbomVersionMetadata.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomVersionMetadata>): AppSecopsSbomVersionMetadata {
        let obj = Object.assign(new AppSecopsSbomVersionMetadata(), model);
        AppSecopsSbomVersionMetadata.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomVersionMetadata>): AppSecopsSbomVersionMetadata {
        if (!model) return null;
        return AppSecopsSbomVersionMetadata.newInstance(<AppSecopsSbomVersionMetadata> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomVersionMetadata) {
        if (!obj) return;

        models.AppSecopsSbomVersionMetadata.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomVersionMetadata): boolean {
        Object.setPrototypeOf(obj, AppSecopsSbomVersionMetadata.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.bom_created_at === "string") {
            this.bom_created_at = new Date(<string><any>this.bom_created_at);
        }
        if (this.tools) {
            for (let val of this.tools) {
                models.AppSecopsSbomVersionMetadataTool.fixupPrototype(val);
            }
        }
    }

    /**
     * Sbom component type
     */
    component_type: models.AppSecopsSbomComponentType;

    tools: Array<models.AppSecopsSbomVersionMetadataTool>;

    /**
     * SBOM build created datetime
     */
    bom_created_at: Date;

}
